'use client';

import { OverlayButton } from '$components/OverlayButton';
import { IconType } from '$components/OverlayIcon';
import { OverlayIcon } from '$components/OverlayIcon/OverlayIcon';
import { ZeroElement } from '$components/ZeroElement';
import { CtaProvider } from '$providers/CtaProvider';
import { LayoutContext } from '$root/src/context';
import cn from 'classnames';
import React, { Suspense, useContext } from 'react';

export function BackDropContent() {
  const useLayoutStore = useContext(LayoutContext);
  const overlayContentOpen = useLayoutStore(
    (state) => state.overlayContentOpen,
  );

  const overLayTitle = useLayoutStore((state) => state.overLayTitle);
  const setOverLayTitle = useLayoutStore((state) => state.setOverLayTitle);
  const overLayAsset = useLayoutStore((state) => state.overLayAsset);
  const setOverLayAsset = useLayoutStore((state) => state.setOverLayAsset);
  const setStartPosX = useLayoutStore((state) => state.setStartPosX);
  const setStartPosY = useLayoutStore((state) => state.setStartPosY);
  const overLayCopy = useLayoutStore((state) => state.overLayCopy);
  const setOverLayCopy = useLayoutStore((state) => state.setOverLayCopy);
  const overlayCtaS = useLayoutStore((state) => state.overlayCtaS);
  const setOverlayCtaS = useLayoutStore((state) => state.setOverlayCtaS);
  const newHeight = useLayoutStore((state) => state.resized);

  const setOverlayOpen = useLayoutStore((state) => state.setOverlayOpen);
  const setOverlayContentOpen = useLayoutStore(
    (state) => state.setOverlayContentOpen,
  );
  const setCallingButton = useLayoutStore((state) => state.setCallingButton);
  const closeOverlay = (e) => {
    setOverlayOpen(() => false);
    setOverlayContentOpen(() => false);
    setCallingButton(() => 'overlay');
    //setStartPosX(() => e.clientX - window.innerWidth / 2);
    //setStartPosY(() => -(e.clientY - window.innerHeight / 2));
    setStartPosX(() => e.clientX);
    setStartPosY(() => e.clientY);
    setTimeout(() => {
      setOverLayTitle(() => '');
      setOverLayCopy(() => null);
      setOverLayAsset(() => '');
      setOverlayCtaS(() => null);
    }, 1000);
  };

  return (
    <div
      style={{
        height: newHeight,
      }}
      className={cn(
        overlayContentOpen
          ? 'visible opacity-100'
          : 'opacity-0 invisible duration-1000',
        'absolute left-0 top-0 w-full lg:flex flex-col items-end justify-center lg:overflow-hidden z-[150]',
        'overflow-y-scroll overflow-x-hidden',
      )}
    >
      <ZeroElement
        className={cn(
          overlayContentOpen
            ? 'opacity-100 delay-1000 duration-300'
            : 'opacity-0 duration-300',
          '-z-[1]',
        )}
        assetType={'colour'}
        type={'static'}
        imageAsset={null}
        videoAsset={null}
        colour={'#ffFFFF'}
      />
      <div
        className={cn(
          'absolute left-[50%] top-[50%] -ml-[36vh] md:-ml-[42.5vh] -mt-[36vh] md:-mt-[42.5vh] h-[72vh] md:h-[85vh] w-[72vh] md:w-[85vh] bg-[length:auto_100vh] md:bg-[length:100vw_auto]',
        )}
      >
        <div
          className={cn(
            'absolute right-[50%] -mr-7 -mt-7 md:-mr-0 md:mt-0 md:right-[12%] md:top-[12%]',
          )}
        >
          <OverlayButton
            action={closeOverlay}
            title={'close'}
            size={'l'}
            type={'light'}
          />
        </div>
      </div>
      <div
        className={cn(
          overlayContentOpen ? 'opacity-100 delay-1000' : 'opacity-0',
          'flex flex-col md:flex-row w-full justify-end items-end p-gutter-mobile md:p-gutter-desktop duration-500 lg:mt-0 mt-[20vh]',
        )}
      >
        <div
          className={cn(
            'flex w-full md:w-1/3 items-start md:items-end justify-start mb-9 md:mb-0 md:justify-center',
          )}
        >
          <OverlayIcon name={overLayAsset as IconType} />
        </div>
        <div
          className={cn(
            'flex w-full md:w-1/3 flex-col items-start justify-center',
          )}
        >
          <h3 className={cn('style-heading-xs mb-2 text-grey-100')}>
            {overLayTitle}
          </h3>
          <div
            className={cn(
              'style-body-m mb-8 text-grey-80',
              //'style-body-m mb-8 max-h-[50%] md:max-h-full overflow-y-scroll',
            )}
          >
            {overLayCopy}
          </div>
          <div className={cn('flex flex-row')}>
            {overlayCtaS !== null &&
              overlayCtaS.items.map((button, index) => {
                return (
                  <Suspense key={index} fallback={null}>
                    <CtaProvider buttonType={null} item={button} key={index} />
                  </Suspense>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
